// scroll bar
import 'simplebar-react/dist/simplebar.min.css';

// lazy image
import 'react-lazy-load-image-component/src/effects/blur.css';

// ----------------------------------------------------------------------

// routes
// import Router from 'src/routes/sections';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
// theme
import ThemeProvider from 'src/theme';
import { LocalizationProvider } from '@mui/x-date-pickers';

// mui

// components
import ProgressBar from 'src/components/progress-bar';
import MotionLazy from 'src/components/animate/motion-lazy';
import { SettingsProvider, SettingsDrawer } from 'src/components/settings';

// auth
import { AuthProvider } from 'src/auth/context/jwt';

// custom components
import MiunskeKonfiguratorStepper from './components/miunske-konfigurator';

import i18n from './locales/i18n';
import { localStorageGetItem } from './utils/storage-available';

// ----------------------------------------------------------------------

export default function App() {
  // useScrollToTop();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const urlLang = params.get('lang');

    // Set language depending on urlLang
    // If urlLang is 'en', use English
    // If urlLang is 'de', use German
    // Otherwise, use German by default
    // if (urlLang === 'en') {
    //   i18n.changeLanguage('en');
    // } else if (urlLang === 'de') {
    //   i18n.changeLanguage('de');
    // }

    // const updateLangAttribute = (lang: string) => {
    //   if (document.documentElement.lang !== lang) {
    //     document.documentElement.lang = lang;
    //   }
    // };

    // updateLangAttribute(i18n.language);

    const handleLanguageChange = (lang: string) => {
      // updateLangAttribute(lang);

      console.log('App mounted');
    };

    i18n.on('languageChanged', handleLanguageChange);

    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, []);

  return (
    <AuthProvider>
      <LocalizationProvider>
        <SettingsProvider
          defaultSettings={{
            themeMode: 'light', // 'light' | 'dark'
            themeDirection: 'ltr', //  'rtl' | 'ltr'
            themeContrast: 'default', // 'default' | 'bold'
            themeLayout: 'vertical', // 'vertical' | 'horizontal' | 'mini'
            themeColorPresets: 'default', // 'default' | 'cyan' | 'purple' | 'blue' | 'orange' | 'red'
            themeStretch: false,
          }}
        >
          <ThemeProvider>
            <MotionLazy>
              <SettingsDrawer />
              <MiunskeKonfiguratorStepper />

              <ProgressBar />
            </MotionLazy>
          </ThemeProvider>
        </SettingsProvider>
      </LocalizationProvider>
    </AuthProvider>
  );
}
